// extracted by mini-css-extract-plugin
module.exports = {"container":"Paged_container__817Cg","page":"Paged_page__2OBhE","button":"Paged_button__6bLsP"};